import api from "@/api"

const state = {
  articles: [],
  article: {}
}

const actions = {
  getArticleList({ commit }, params) {
    return api.article.articleList(params).then((response) => {
      commit("setArticles", response.data)
      return response
    })
  },
  getArticle({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.article.articleDetail(id).then(
        (response) => {
          commit("setArticle", response.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  createArticle({ commit }, payloads) {
    return new Promise((resolve, reject) => {
      api.article.articleCreate(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateArticle({ commit }, { payloads, id }) {
    return new Promise((resolve, reject) => {
      api.article.articleUpdate(payloads, id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteArticle({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.article.articleDelete(id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setArticles(state, value) {
    state.articles = value
  },
  setArticle(state, value) {
    state.article = value
  }
}

const getters = {
  articles: (state) => state.articles,
  article: (state) => state.article
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
